// Copy the academy area's screens and components added while moving to the design system (src/ui).
// One entry per locale; every key exists in all seven (nl is the source, the rest are translations).
export const academyCopy = {
  nl: {
    "learn.term.pin": "Uitleg vastzetten",
    "learn.term.unpin": "Uitleg loslaten",
    "learn.term.menu-explain": "Uitleg tonen",
    "learn.term.menu-copy": "Woord kopiëren",
    "learn.level.menu-open": "Niveau openen",
    "learn.path.refresh": "Vernieuwen",
  },
  en: {
    "learn.term.pin": "Pin the explanation",
    "learn.term.unpin": "Unpin the explanation",
    "learn.term.menu-explain": "Show the meaning",
    "learn.term.menu-copy": "Copy the word",
    "learn.level.menu-open": "Open the level",
    "learn.path.refresh": "Refresh",
  },
  de: {
    "learn.term.pin": "Erklärung festhalten",
    "learn.term.unpin": "Erklärung lösen",
    "learn.term.menu-explain": "Bedeutung zeigen",
    "learn.term.menu-copy": "Wort kopieren",
    "learn.level.menu-open": "Stufe öffnen",
    "learn.path.refresh": "Aktualisieren",
  },
  fr: {
    "learn.term.pin": "Épingler l’explication",
    "learn.term.unpin": "Détacher l’explication",
    "learn.term.menu-explain": "Afficher le sens",
    "learn.term.menu-copy": "Copier le mot",
    "learn.level.menu-open": "Ouvrir le niveau",
    "learn.path.refresh": "Actualiser",
  },
  es: {
    "learn.term.pin": "Fijar la explicación",
    "learn.term.unpin": "Soltar la explicación",
    "learn.term.menu-explain": "Mostrar el significado",
    "learn.term.menu-copy": "Copiar la palabra",
    "learn.level.menu-open": "Abrir el nivel",
    "learn.path.refresh": "Actualizar",
  },
  it: {
    "learn.term.pin": "Fissa la spiegazione",
    "learn.term.unpin": "Sgancia la spiegazione",
    "learn.term.menu-explain": "Mostra il significato",
    "learn.term.menu-copy": "Copia la parola",
    "learn.level.menu-open": "Apri il livello",
    "learn.path.refresh": "Aggiorna",
  },
  pt: {
    "learn.term.pin": "Fixar a explicação",
    "learn.term.unpin": "Soltar a explicação",
    "learn.term.menu-explain": "Mostrar o significado",
    "learn.term.menu-copy": "Copiar a palavra",
    "learn.level.menu-open": "Abrir o nível",
    "learn.path.refresh": "Atualizar",
  },
} as const;
